<template>
    <div :class="[{ 'double-new-style': doubleNew }]">
        <CommonTitle
            :title="modelTitle"
            :showMore="true"
            @goMore="goMore"
            :tag-list="tagList"
            @changeTag="onChangeTag"
        />
        <ul class="course-list" v-if="list.length" v-loading="loading">
            <li
                class="course-list-item"
                v-for="item in list"
                :key="item.id"
                @click="goDetail(item.id)"
            >
                <div class="course-list-item-link" v-link="linkUrl(item.id)">
                    <div class="list-item-img">
                        <span class="tag" v-if="item.courseCreditTypeName">{{
                            item.courseCreditTypeName?.slice(0, 6) || ''
                        }}</span>
                        <LazyImage :src="item.previewUrl" className="img" />
                    </div>
                    <div class="list-item-content">
                        <p class="title flex-start">
                            <span class="name text-overflow" :title="item.courseName">{{
                                item.courseName
                            }}</span>
                        </p>
                        <p
                            class="semester-stage text-overflow"
                            :title="`学段学科：${item.stageSubjectName}`"
                        >
                            学段学科：{{ item.stageSubjectName }}
                        </p>
                        <p
                            class="create-title text-overflow"
                            :title="`发布人：${item.publishUserName}`"
                        >
                            <label class="label-pre-border">发布人：</label
                            >{{ item.publishUserName }}
                        </p>
                        <span class="btn-report"
                            ><el-icon class="report-icon"><Promotion /></el-icon>报名学习</span
                        >
                    </div>
                </div>
            </li>
        </ul>
        <BigNoData
            v-else
            class="no-data"
            url="no-course.png"
            :info="`暂无${modelTitle || '研修课程'}`"
        />
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/index.vue';
import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { pageJump } from '@/global/location-transfer';
import { handleStageSubject } from '@/lib/tools';

import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Promotion } from '@element-plus/icons-vue';

const props = defineProps({
    modelTitle: {
        type: String,
        default: '',
    },
    tagList: {
        type: Array,
        default: () => {
            return [];
        },
    },
    doubleNew: {
        type: Boolean,
        default: false,
    },
    fromTemplateId: [Number, String],
});

const list = ref([]);
const store = useStore();
const router = useRouter();

// const tagList = ref([
//     {
//         id: 'time',
//         name: '最新'
//     },
//     {
//         id: 'hot',
//         name: '最热'
//     }
// ])

const curTab = ref('time');

const loading = ref(false);
const stageIds = ref('');
const obj = {
    type: 'network',
};

function getList() {
    loading.value = true;
    G_transmit('courseSquareList', {
        name: 'courseSquareList',
        queries: {
            courseType: 1, // 默认1 1 研修课程
            pageIndex: 1,
            pageSize: 4,
            orderBy: 'desc',
            // sortBy: curTab.value,
            sortBy: 'time',
            stageIds: stageIds.value,
        },
    })
        .then(res => {
            let arr = res.data?.rows || [];
            list.value =
                (arr.length &&
                    arr.map(item => {
                        item.stageSubjectName = handleStageSubject(item.subjectStageGrade, '暂无');
                        return item;
                    })) ||
                [];
        })
        .finally(() => {
            loading.value = false;
        });
}

function goMore() {
    // pageJump({name: 'courseSquare'});
    pageJump({ name: 'districtCourseSquare' });
}

function goDetail(id) {
    pageJump(
        {
            name: 'courseDetails',
            query: {
                courseId: id,
            },
        },
        true,
    );
}

function linkUrl(id) {
    const url = router.resolve({ name: 'courseDetails' }).path;
    return {
        url: `${url}?courseId=${id}`,
        className: 'link-item',
    };
}

const onChangeTag = tag => {
    stageIds.value = tag.join(',');
    getList();
};

onMounted(() => {
    let tag = props.doubleNew ? [1204] : [];
    onChangeTag(tag);
});
</script>

<style lang="scss" scoped>
.course-list {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}

.course-list-item {
    box-sizing: border-box;
    width: calc(50% - 17px);
    border-radius: 4px;
    margin-right: 34px;
    margin-top: 20px;
    display: flex;
    cursor: pointer;

    &:nth-child(1),
    &:nth-child(2) {
        margin-top: 26px;
    }

    &:nth-child(2n) {
        margin-right: 0;
    }

    &:hover {
        .name {
            color: var(--home-main-color) !important;
        }
    }

    .list-item-img {
        width: 116px;
        height: 156px;
        border-radius: 5px;
        position: relative;
        .tag {
            background: #222222cc;
            border-radius: 6px 0px 6px 0px;
            font-size: 14px;
            color: var(--srt-color-white);
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 100;
            padding: 2px 5px 2px 6px;
        }

        .img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
        }
    }

    .list-item-content {
        box-sizing: border-box;
        position: relative;
        padding: 8px 0px 0px 20px;
        width: calc(100% - 116px);
        flex: calc(100% - 116px) 0 0;

        .title {
            margin-bottom: 12px;
            white-space: nowrap;
        }
        .title-tag {
            border-radius: 6px 6px 2px 6px;
            display: inline-block;
            font-size: 14px;
            padding: 1px 7px;
            margin-right: 8px;
        }
        .name {
            font-weight: bold;
            color: var(--srt-main-text-color);
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-size: 16px;
            display: inline-block;
        }

        .class-tag {
            background: #e8f0ef;
            color: #2d6c58;
        }

        .stage-tag {
            background: #ebedf6;
            color: #3c4773;
        }

        .project-tag {
            background: #eeebe9;
            color: #654a30;
        }

        .network-tag {
            background: #e5f0f3;
            color: #265f6f;
        }

        .semester-stage {
            color: var(--srt-main-text-color);
        }
        .create-title {
            margin-top: 12px;
            color: var(--srt-color-gray);
        }
        .btn-report {
            width: 110px;
            line-height: 32px;
            font-size: 16px;
            color: var(--home-main-color);
            background: var(--home-color-bg);
            border-radius: 4px;
            margin-top: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            .report-icon {
                font-size: 20px;
                margin-right: 4px;
            }
        }
    }
}
:deep(.link-item) {
    width: 100%;
    .course-list-item-link {
        display: flex;
    }
}
.course-title {
    flex: 1;
    padding: 0px 30px;
    margin-bottom: 15px;
    color: var(--srt-color-gray);
    cursor: pointer;
    span {
        margin-right: 20px;
        &.active {
            color: var(--home-main-color);
        }
    }
}

.no-data {
    margin-top: 50px;
}

.double-new-style {
    .list-item-content {
        padding: 13px 0px 0px 20px;
        .name {
            line-height: 16px;
        }
        .semester-stage {
            line-height: 14px;
        }
        .create-title {
            margin-top: 10px;
            line-height: 14px;
        }
        .btn-report {
            margin-top: 20px;
        }
    }
}
</style>
